import type { VoidFunctionComponent } from 'react';

import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import Section from '../../../shared/settings/SettingsPageSection';

import type { GenericIssueSettingsProps } from './types';

/**
 * ProjectQualityIssuesSettings
 */
const ProjectQualityIssuesSettings: VoidFunctionComponent<GenericIssueSettingsProps> = (props) => {
  return (
    <Section>
      <Section.Left heading="Quality">
        <Section.Paragraph>Configuration for quality issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Quality}
          scopeType={IssueScopeKind.Project}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectQualityIssuesSettings;
